import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import {
  Grid, Select, MenuItem, Button, FormLabel
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core';
import { SUPPORTED_LANGUAGES } from '../../utils/const';
import { setUserLanguage } from '../../utils/language';
import { editLanguage } from '../../actions/employee.action';

const Language = () => {
  const dispatch = useDispatch();
  const employee = useSelector(state => state.employee);
  const [ language, setLanguage ] = useState(employee.language);
  const { t } = useTranslation();

  useEffect(() => {
    setUserLanguage(employee.language);
    setLanguage(employee.language);
  }, [ employee ]);

  const useStyles = makeStyles({
    saveBtn: {
      marginTop: '10px'
    },
    label: {
      color: '#999999',
      fontSize: '16px',
      textTransform: 'uppercase'
    },
    select: {
      paddingTop: '15px',
      maxWidth: '280px',
      width: '100%'
    }
  });

  const classes = useStyles();

  const handleLanguageChange = event => {
    setLanguage(event.target.value);
  };

  const handleOnSaveLanguage = () => {
    dispatch(editLanguage(language.toLowerCase()));
  };

  return (
    <Grid>
      <Grid container direction="row">
        <FormLabel className={ classes.label }>
          { t('settings.language.title') }
        </FormLabel>
      </Grid>
      <Select
        value={ language ? language.toUpperCase() : '' }
        onChange={ handleLanguageChange }
        className={ classes.select }>
        { Object.keys(SUPPORTED_LANGUAGES).map(lang =>
          <MenuItem
            key={ SUPPORTED_LANGUAGES[lang] }
            value={ SUPPORTED_LANGUAGES[lang].toUpperCase() }>
            { SUPPORTED_LANGUAGES[lang].toUpperCase() }
          </MenuItem>
        ) }
      </Select>
      <Grid container justifyContent="flex-end">
        <Button
          onClick={ handleOnSaveLanguage }
          color="primary"
          variant="contained"
          className={ `${classes.saveBtn} update-language` }
          disabled={ !language || language.toLowerCase() === employee.language }
        >
          <div>{ t('settings.language.save') }</div>
        </Button>
      </Grid>
    </Grid>
  );
};

export default Language;
